import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MoneySigned from "app/components/MoneySigned";
import classNames from "classnames";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
const MobileTransaction = ({ transaction, }) => {
    const pendingClassName = classNames([
        { "money-pending": transaction.IsPending },
    ]);
    const style = {
        marginBottom: "0.2rem",
        marginRight: "0.2rem",
        fontSize: "small",
    };
    return (_jsxs("div", { style: { textAlign: "end" }, children: [transaction.IsPending && _jsx(WatchLaterIcon, { style: style }), !!transaction.Decrease && (_jsx(MoneySigned, { amount: transaction.Decrease, direction: "credit", className: pendingClassName, addColour: true })), !!transaction.Increase && (_jsx(MoneySigned, { amount: transaction.Increase, direction: "debit", className: pendingClassName }))] }));
};
export default MobileTransaction;
